import { getItem } from '../cookies/cookies';

class AuthHelper {
  constructor() {}
  checkAuth() {
    let token = getItem('token');
    let refreshToken = getItem('refresh_token');
    return token || refreshToken;
  }
}

export default new AuthHelper();
